import React from 'react';
import classname from 'classnames';
import './SettingsPane.pcss';

type Props = {
  title: string;
  className?: string;
  children: React.ReactNode | React.ReactNode[];
};
export const SettingsPane = (props: Props) => {
  const { title, className, children } = props;
  return (
    <div className={classname('settings-pane', className)}>
      <h1 className="settings-pane__title">{title}</h1>
      {children}
    </div>
  );
};
